export class DFCountry {
   public countryCode: string;
   public countryName: string;
   public timeZone: string;
   public fixedChargesFrequency: string;
   public assetSearchFrequency: string;
   public assetSearchDay: string;
   public assetSearchWeek: string;
   public assetSearchMonth: string;
   public loadSearchFrequency: string;
   public loadSearchDay: string;
   public loadSearchWeek: string;
   public loadSearchMonth: string;
   public autoCalculateFrequency: string;
   public autoCaculateDay: string;
   public autoCaculateWeek: string;
   public autoCaculateMonth: string;
   public voucherJobFrequency: string;
   public voucherJobDay: string;
   public voucherJobWeek: string;
   public voucherJobMonth: string;
   public selectSchedulersFrequency: string;
   public selectSchedulersDay: string;
   public selectSchedulersWeek: string;
   public selectSchedulersMonth: string;
   public sequencialType: string;
   public days: string;
   public initialVoucherCharge: string;
}


export class DFDaysOfWeek {
  daysOfWeek: any[];
  instances: DFInstances[];
}

export class DaysOfWeeks {
    daysOfWeek: string;
}

export class DFInstances {
    hour: string;
    minute: string;
}

export class FrequencyTime {
    frequency: string;
}

export class FixedChargesFrequency {
    charges: string;
}

export class TimeZone {
    id: string;
    time_zone: string;
}

export class Days {
    Name: string;
    Value: string;
}

export const searchFrequency = [
    { frequency: 'once a day' , value: 'ONCE_A_DAY' },
    { frequency: 'specific day of month' , value: 'SPECIFIC_DAYS_OF_MONTH' },
    { frequency: 'last day of month' , value: 'LAST_DAY_OF_MONTH' },
    { frequency: 'every six hours' , value: 'EVERY_SIX_HOURS' }
];

export const fixedChargeFrequency = [
    { charges: 'Daily' },
    { charges: 'Weekly' },
    { charges: 'Monthly' },
    { charges: 'Custom' },
];

export const days = [
    { id: 1, Name: 'Sun', Value: 'SUNDAY', selected: false},
    { id: 2, Name: 'Mon', Value: 'MONDAY', selected: false},
    { id: 3, Name: 'Tue', Value: 'TUESDAY', selected: false},
    { id: 4, Name: 'Wed', Value: 'WEDNESDAY', selected: false},
    { id: 5, Name: 'Thu', Value: 'THURSDAY', selected: false},
    { id: 6, Name: 'Fri', Value: 'FRIDAY',   selected: false},
    { id: 7, Name: 'Sat', Value: 'SATURDAY', selected: false}
  ];
  export class DFMonthlyDataRequest {
    id: number;
    country_code: string;
    created_date: string;
    month: string;
    month_end_date: string;
    month_start_date: string;
    updated_date: string;
    voucher_grace_days: number;
    voucher_update_date: string;
    year: number;
    number_of_days: number
  }
  export class DFMonthlyDataDto {
    id: number;
    countryCode: string;
    createdDate: string;
    month: string;
    monthEndDate: string;
    monthStartDate: string;
    numberOfDays: number;
    updatedDate: string;
    voucherGraceDays: number;
    voucherUpdateDate: string;
    year: number;
    minEndDate: string;

    static fromDto(d: any): DFMonthlyDataDto {
        if (!d) {
          return null;
        }
        const monthlyDto = new DFMonthlyDataDto();
        monthlyDto.id             = d.id;
        monthlyDto.year           = d.year;
        monthlyDto.month          = d.month;
        monthlyDto.countryCode    = d.country_code;
        monthlyDto.createdDate    = d.created_date;
        monthlyDto.updatedDate    = d.update_date;
        monthlyDto.monthStartDate = this.formatStringDate(d.month_start_date);
        monthlyDto.monthEndDate   = this.formatStringDate(d.month_end_date);
        monthlyDto.numberOfDays   = d.number_of_days;
        monthlyDto.voucherUpdateDate = this.formatStringDate(d.voucher_update_date);
        monthlyDto.voucherGraceDays  = d.voucher_grace_days;
        return monthlyDto;
      }

      static formatStringDate(date: string) {
        if (!date) {
        return null;
        }
        return this.formatDate(new Date(date));
      }


      static formatDate(date: Date): string {
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();
        month = month.length === 1 ? '0' + month : month;
        day = day.length === 1 ? '0' + day : day;
        return year + '-' + month + '-' + day;
      }

      static toDto(r: DFMonthlyDataDto): DFMonthlyDataRequest {
        if (!r) {
          return null;
        }

        return {
            id: r.id,
            country_code: r.countryCode,
            created_date: r.createdDate,
            month: r.month,
            month_end_date: r.monthEndDate,
            month_start_date: r.monthStartDate,
            number_of_days: r.numberOfDays,
            updated_date: r.updatedDate,
            voucher_grace_days: r.voucherGraceDays,
            voucher_update_date: r.voucherUpdateDate,
            year: r.year
        };
      }
  }


